export default {"src":"/_next/static/media/Trash.018c25f7.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};